import get from 'lodash/get';
import forEach from 'lodash/forEach';
import keyBy from 'lodash/keyBy';
import flatten from 'lodash/flatten';

import { caseLogicMsg, dialogueMsg } from '../validationMessages';

function validateDialogueControls(caseConf, nodeInfo) {
  const questions = get(caseConf, 'dialogue.questions', []);
  const commands = get(caseConf, 'dialogue.commands', []);
  const unsolicited = get(caseConf, 'dialogue.unsolicited', []);
  const callItems = flatten((get(caseConf, 'dialogue.calls') || []).map(call => call.items))
  const callUnsolicited = flatten((get(caseConf, 'dialogue.calls') || []).map(call => call.unsolicited))
  const questionsById = keyBy(questions, 'id');
  const commandsById = keyBy(commands, 'id');
  const unsolicitedById = keyBy(unsolicited, 'id');
  const callItemsById = keyBy(callItems, 'id');
  const callUnsolicitedById = keyBy(callUnsolicited, 'id');

  const errors = [];
  const warnings = [];

  const dialogueItemsByTypeById = {
    QUESTION: questionsById,
    ANSWER: questionsById,
    COMMAND: commandsById,
    COMMAND_COUNT: commandsById,
    UNSOLICITED_DIALOGUE: unsolicitedById,
    UNSOLICITED_CALL: callUnsolicitedById,
    CALL: callItemsById,
    CALL_ANSWER: callItemsById,
  };
  const dialogueTitleByType = {
    QUESTION : 'Question',
    ANSWER: 'Question',
    COMMAND: 'Command',
    COMMAND_COUNT: 'Command',
    UNSOLICITED_DIALOGUE: 'Unsolicited',
    UNSOLICITED_CALL: 'Unsolicited',
    CALL: 'Call dialogue',
    CALL_ANSWER: 'Call dialogue',
  };
  const dialogueArticleByType = {
    QUESTION : 'a',
    ANSWER: 'a',
    COMMAND: 'a',
    COMMAND_COUNT: 'a',
    UNSOLICITED_DIALOGUE: 'an',
    UNSOLICITED_CALL: 'an',
    CALL: 'a',
    CALL_ANSWER: 'a',
  };

  // Action nodes
  const dialogueActionTypes = ['QUESTION', 'COMMAND', 'CALL'];

  nodeInfo.actionNodes.forEach((node) => {
    const action = get(node, 'data.action');
    if (action && dialogueActionTypes.includes(action.type)) {
      const dialogueTitle = dialogueTitleByType[action.type];
      const dialogueArticle = dialogueArticleByType[action.type];
      if (!action.id) {
        errors.push(caseLogicMsg(`You need to select ${dialogueArticle} ${dialogueTitle.toLowerCase()}`, node.id));
        return;
      }
      const dialogueItem = dialogueItemsByTypeById[action.type][action.id];
      if (!dialogueItem) {
        errors.push(caseLogicMsg(`${dialogueTitle} could not be found`, node.id));
      }
    }
  });

  // Effect nodes
  const dialogueEffectTypes = ['QUESTION', 'ANSWER', 'COMMAND', 'CALL', 'CALL_ANSWER', 'UNSOLICITED_DIALOGUE', 'UNSOLICITED_CALL'];

  nodeInfo.effectNodes.forEach((node) => {
    const effect = get(node, 'data.effect');
    if (effect && dialogueEffectTypes.includes(effect.type)) {
      const dialogueTitle = dialogueTitleByType[effect.type];
      const dialogueArticle = dialogueArticleByType[effect.type];
      if (!effect.id) {
        errors.push(caseLogicMsg(`You need to select ${dialogueArticle} ${dialogueTitle.toLowerCase()}`, node.id, { errorId: 'missingQuestion' }));
        return;
      }
      const dialogueItem = dialogueItemsByTypeById[effect.type][effect.id];
      if (!dialogueItem) {
        errors.push(caseLogicMsg(`${dialogueTitle} could not be found`, node.id, { errorId: 'invalidQuestion' }));
      } else if (effect.type === 'UNSOLICITED_DIALOGUE') {
        if (!dialogueItem.options.answer || !dialogueItem.options.answer.en) {
          errors.push(dialogueMsg('Empty unsolicited item', dialogueItem.id, { errorId: 'emptyUnsolicited', dialogueType: 'UNSOLICITED' }));
        }
      }
    }
  });


  // Check nodes
  const dialogueCheckTypes = ['QUESTION', 'COMMAND_COUNT', 'UNSOLICITED_DIALOGUE', 'CALL', 'UNSOLICITED_DIALOGUE', 'UNSOLICITED_CALL'];

  nodeInfo.checkNodes.forEach((node) => {
    forEach(node.data, (check, checkKey) => {
      if (dialogueCheckTypes.includes(check.type)) {
        const dialogueTitle = dialogueTitleByType[check.type];
        const dialogueArticle = dialogueArticleByType[check.type];
        if (!check.id) {
          errors.push(caseLogicMsg(`You need to select ${dialogueArticle} ${dialogueTitle.toLowerCase()}`, node.id, { checkKey }));
          return;
        }
        const dialogueItem = dialogueItemsByTypeById[check.type][check.id];
        if (!dialogueItem) {
          errors.push(caseLogicMsg(`${dialogueTitle} could not be found`, node.id, { checkKey }));
        }
      }
    });
  });

  return {
    errors,
    warnings,
  };
}

export default validateDialogueControls;
